import axios from 'axios'
import { host } from '../../helper/config'

const PLUGINS_NAME = 'admin-calculate-reward'

// keno
export const calculateKeno = async (token, periodId) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/keno`, {
        periodId: periodId
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}

// max3d
export const calculateMax3d = async (token, periodId) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/max3d`, {
        periodId: periodId
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}

// max3dpro
export const calculateMax3dPro = async (token, periodId) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/max3dpro`, {
        periodId: periodId
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}

// mega
export const calculateMega = async (token, periodId) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/mega`, {
        periodId: periodId
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}

// power
export const calculatePower = async (token, periodId) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/power`, {
        periodId: periodId
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}

// lotto535
export const calculateLotto535 = async (token, periodId) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/lotto535`, {
        periodId: periodId
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}

export const getCalculateRewardProgress = async (token, periodId) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/progress`, {
        periodId: periodId
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}